import { Model } from "@interfaces/model.interface";

export interface ToolingType extends Model {
	isActive: boolean;
	name: string;
}

export class ToolingType implements ToolingType {
	constructor(data?: Partial<ToolingType>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}